import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { Navigate } from 'react-router-dom'; // add this at the topgit
import ScrollToTop from './utils/hooks/ScrollToTop';
import Navbar from './components/organisms/Navbar';
import TopBar from './components/organisms/TopBar';
import Footer from './components/organisms/Footer';
import { useEffect } from 'react';
import NotFoundPage from './views/NotFound/NotFoundPage';
import PageRoutes from './routes/PageRoutes';
import { pageview } from './utils/analytics';

function AppWrapper() {
  const location = useLocation();
  const routes = PageRoutes(location.key);
  const matched = routes.find((route) => route.path === location.pathname);

  useEffect(() => {
    const pageTitle = matched ? matched.title : 'Guidepost - Page Not Found';
    document.title = pageTitle;

    pageview(location.pathname + location.search, pageTitle);
  }, [matched, location]);

  return (
    <>
      <ScrollToTop />
      <TopBar />
      {matched && <Navbar />}
      <Routes>
        {routes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
        {/* 🔁 Redirects from old URLs */}
        <Route
          path="/guidepost-staff"
          element={<Navigate to="/our-team" replace />}
        />
        <Route
          path="/employment-opportunities"
          element={<Navigate to="/contact" replace />}
        />
        <Route
          path="/contact-us"
          element={<Navigate to="/contact" replace />}
        />
        <Route path="/about-us-2" element={<Navigate to="/about" replace />} />
        <Route
          path="/expect"
          element={<Navigate to="/appointment" replace />}
        />
        <Route
          path="/physical-therapy"
          element={<Navigate to="/services/physical-therapy" replace />}
        />
        <Route
          path="/occupational-therapy"
          element={<Navigate to="/services/occupational-therapy" replace />}
        />
        <Route
          path="/speech-therapy"
          element={<Navigate to="/services/speech-therapy" replace />}
        />
        <Route
          path="/community-impact"
          element={<Navigate to="/about/community-impact" replace />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
